export enum UserType {
  Person = 0,
  Operator = 1,
  AI = 2,
}
